import { createFileRoute } from "@tanstack/react-router";

import { AreaPage } from "@/components/site/AreaPage";
import { JsonLd } from "@/components/site/JsonLd";
import { AREAS, areaJsonLd } from "@/content/areas";
import { PAGE_META } from "@/content/page-meta";
import { absoluteUrl, seoLinks, ogImage } from "@/lib/seo";

const PATH = "/svensk-skola-marbella";
const meta = PAGE_META["area:marbella:sv"];

export const Route = createFileRoute("/svensk-skola-marbella")({
  head: () => ({
    meta: [
      { title: meta.title },
      { name: "description", content: meta.description },
      { property: "og:title", content: meta.title },
      { property: "og:description", content: meta.description },
      { property: "og:type", content: "article" },
      { property: "og:url", content: absoluteUrl(PATH) },
      { name: "twitter:card", content: "summary_large_image" },
      { property: "og:locale", content: "sv_SE" },
      ...ogImage(),
    ],
    links: seoLinks(PATH),
  }),
  component: MarbellaRoute,
});

function MarbellaRoute() {
  const content = AREAS.marbella.sv;
  return (
    <>
      <JsonLd scripts={areaJsonLd(content, absoluteUrl(PATH), "sv")} />
      <AreaPage locale="sv" content={content} currentSvPath={PATH} />
    </>
  );
}
